import * as yup from 'yup';

export const updateUserDataSchema = yup.object({
	name: yup.string().notRequired(),
});
